import axios from "axios";
import authHeader from "./auth-header";
import ITechnique from "../types/technique.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/technique`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (technique: ITechnique) => {
  return axios.post(API_URL, technique, { headers: authHeader() });
};

export const update = (id: number, technique: ITechnique) => {
  return axios.put(API_URL + "/" + id, technique, { headers: authHeader() });
};

export const getTechniques = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getActiveTechniques = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};
